"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocation = exports.hasAnyVideoPhoneAppt = exports.getVisitTypeTitle = exports.getProviderImageUrl = exports.getProviderContactNumber = exports.getMainContactNumber = exports.getAppointmentLocation = exports.getAppointmentDate = exports.formatProviderSpecialties = exports.formatProviderName = exports.formatProviderDegrees = exports.formatLocation = void 0;
const moment_1 = __importDefault(require("moment"));
const images_1 = require("./constants/images");
const visitTypes_1 = require("./constants/visitTypes");
const types_1 = require("../../types");
const formatLocation = ({ street1, street2, suite, city, state, zip }) => {
    // Combine street address components and city with commas
    const streetAndCityAddress = [street1, street2, suite, city]
        .filter((component) => !!component)
        .join(', ');
    // Combine state and zip with a space
    const stateAndZipCode = [state, zip]
        .filter((component) => !!component)
        .join(' ');
    // Create the complete formatted address
    const formattedAddress = [streetAndCityAddress, stateAndZipCode]
        .filter((component) => !!component)
        .join(', ');
    return formattedAddress;
};
exports.formatLocation = formatLocation;
const formatProviderDegrees = (degrees = []) => degrees
    .filter(({ name }) => !!name)
    .map(({ name }) => name)
    .join(',');
exports.formatProviderDegrees = formatProviderDegrees;
const formatProviderName = ({ name, degrees }) => {
    const formattedDegrees = (0, exports.formatProviderDegrees)(degrees);
    return [name.full, formattedDegrees ? ` ${formattedDegrees}` : null]
        .filter((v) => !!v)
        .join();
};
exports.formatProviderName = formatProviderName;
const formatProviderSpecialties = (specialties = []) => specialties
    .filter((specialty) => !!specialty.name)
    .map((specialty) => specialty.name)
    .join(', ');
exports.formatProviderSpecialties = formatProviderSpecialties;
const getAppointmentDate = (selectedAppointment) => {
    const appointmentDate = {};
    const rawDate = (0, moment_1.default)(selectedAppointment.start_datetime);
    appointmentDate.formattedDate = rawDate.format('dddd, MMMM DD, YYYY');
    appointmentDate.formattedTime = rawDate.format('h:mm A');
    return appointmentDate;
};
exports.getAppointmentDate = getAppointmentDate;
/**
 *
 * @param {ProviderLocation[]} locations List of a provider's locations
 * @param {Appointment} appointment The appointment object to get the location for
 * @returns {ProviderLocation} Location object corresponding to the appointment
 */
const getAppointmentLocation = (locations, appointment) => {
    return locations.find((location) => {
        return location.id.toString() === appointment.location_id.toString();
    });
};
exports.getAppointmentLocation = getAppointmentLocation;
/**
 * If the appointment is set, will look at the providers locations and return the phone number associated with
 * the appointment's location if able. Otherwise, will return either the provider's contact number, the phone
 * number of the first location returned, or an empty string.
 * @param {Provider} provider The provider to get the number for.
 * @param {ProviderLocation[]} locations List of locations to help identify appropriate appointment number
 *                                       or to fall back on for phone number.
 * @param {Appointment} appointment Optional appointment used to determine location to use number from.
 * @returns {string} String representation of the best phone number to display.
 */
const getMainContactNumber = (provider, locations = null, appointment = null) => {
    if (locations && appointment) {
        const apptLocation = (0, exports.getAppointmentLocation)(locations, appointment);
        if (apptLocation && apptLocation.phone) {
            return apptLocation.phone;
        }
    }
    const providerPhone = (0, exports.getProviderContactNumber)(provider);
    if (providerPhone) {
        return providerPhone;
    }
    return locations && locations[0] && locations[0].phone
        ? locations[0].phone
        : '';
};
exports.getMainContactNumber = getMainContactNumber;
/**
 * Returns the contact number for a given provider
 * @param {Provider} provider The provider to get the number for.
 * @returns {string} String representation of the best phone number to display.
 */
const getProviderContactNumber = (provider) => {
    const { contacts = [] } = provider;
    const { value } = contacts.find((val) => val.contact_type === 'phone') || {};
    return value;
};
exports.getProviderContactNumber = getProviderContactNumber;
/**
 * Given a provider, return the provider image or
 * a placeholder based on the provider's gender
 * @param {Provider} provider
 */
const getProviderImageUrl = (provider) => {
    const { image_url, gender } = provider || {};
    if (image_url) {
        return image_url;
    }
    else if (gender) {
        const lcGender = gender.toLowerCase();
        if (lcGender === 'male') {
            return images_1.MALE_PROVIDER_AVATAR_URL;
        }
        else if (lcGender === 'female') {
            return images_1.FEMALE_PROVIDER_AVATAR_URL;
        }
    }
    return images_1.NEUTRAL_PROVIDER_AVATAR_URL;
};
exports.getProviderImageUrl = getProviderImageUrl;
const getVisitTypeTitle = (type) => {
    const visitTypeToTitleMap = {
        [types_1.VisitType.IN_PERSON]: visitTypes_1.APPOINTMENT_IN_PERSON_TITLE,
        [types_1.VisitType.PHONE]: visitTypes_1.APPOINTMENT_PHONE_TITLE,
        [types_1.VisitType.VIDEO]: visitTypes_1.APPPOINTMENT_VIDEO_TITLE
    };
    return type ? visitTypeToTitleMap[type] : '';
};
exports.getVisitTypeTitle = getVisitTypeTitle;
const hasAnyVideoPhoneAppt = (query = '') => {
    return [types_1.VisitType.PHONE, types_1.VisitType.VIDEO].includes(query);
};
exports.hasAnyVideoPhoneAppt = hasAnyVideoPhoneAppt;
/**
 * Gets the location for the appointment
 *
 * @param selectedAppointment {Appointment} The selected appointment
 * @param locations {ProviderLocation[]} The locations for the provider
 * @param selectedLocation {ProviderLocation} The selected location
 *
 * @returns {ProviderLocation | undefined} The location for the appointment
 */
const getLocation = (selectedAppointment, locations, selectedLocation) => {
    if (selectedLocation)
        return selectedLocation;
    return selectedAppointment && locations
        ? (0, exports.getAppointmentLocation)(locations, selectedAppointment)
        : undefined;
};
exports.getLocation = getLocation;
//# sourceMappingURL=utils.js.map